import {
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENT_DETAILS,
  GET_EVENT_DETAILS_SUCCESS,
  SET_EVENT_DETAILS_STATUS,
  API_ERROR,
  GET_PENALTIES,
  GET_PENALTIES_SUCCESS,
  GET_EVENTS_LOCATIONS,
  GET_EVENTS_LOCATIONS_SUCCESS,
  REFRESH_EVENTS,
  EVENTS_REFRESHED,
  REFRESH_EVENT_ANNOUNCEMENTS,
  EVENT_ANNOUNCEMENTS_REFRESHED,
} from "./actionTypes"
import { EVENT_DETAILS_READ_MODE_FULL } from "./eventDetailsReadPolicy"

export const getPenalties = (activeFilters, options) => {
  return {
    type: GET_PENALTIES,
    payload: [activeFilters, options],
  }
}

export const getPenaltiesSuccess = penalties => {
  return {
    type: GET_PENALTIES_SUCCESS,
    payload: penalties,
  }
}

export const getEvents = (filters, options, eventTimeFilter) => {
  const filtersJSON = JSON.stringify(filters)
  const optionsJSON = JSON.stringify(options)

  return {
    type: GET_EVENTS,
    filters: filtersJSON,
    options: optionsJSON,
    time: eventTimeFilter,
    payload: [],
  }
}

export const getEventsLocations = (filters, time) => {
  return {
    type: GET_EVENTS_LOCATIONS,
    payload: { time: time, filters: filters },
  }
}

export const getEventsLocationsSuccess = locations => {
  return {
    type: GET_EVENTS_LOCATIONS_SUCCESS,
    payload: locations,
  }
}

export const getEventsSuccess = events => {
  return {
    type: GET_EVENTS_SUCCESS,
    payload: events,
  }
}

// The list read again in the background while its texts translate (ADR 0013), and the fresh read.
export const refreshEvents = (filters, options, eventTimeFilter) => {
  return {
    type: REFRESH_EVENTS,
    filters,
    options,
    time: eventTimeFilter,
  }
}

export const eventsRefreshed = events => {
  return {
    type: EVENTS_REFRESHED,
    payload: events,
  }
}

// An event's announcements read again in the background while one's text translates, and the fresh announcements of that event.
export const refreshEventAnnouncements = id => {
  return {
    type: REFRESH_EVENT_ANNOUNCEMENTS,
    id,
  }
}

export const eventAnnouncementsRefreshed = (id, announcements) => {
  return {
    type: EVENT_ANNOUNCEMENTS_REFRESHED,
    id,
    announcements,
  }
}

export const getEventDetails = (
  id,
  readMode = EVENT_DETAILS_READ_MODE_FULL,
  competitionId
) => {
  return {
    type: GET_EVENT_DETAILS,
    payload: { id, readMode, competitionId },
  }
}

export const getEventDetailsSuccess = eventDetails => {
  return {
    type: GET_EVENT_DETAILS_SUCCESS,
    payload: [eventDetails],
  }
}

export const setEventDetailsStatus = status => {
  return {
    type: SET_EVENT_DETAILS_STATUS,
    payload: status,
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
